let isLoggingOut = false;

const HandleLogout = (navigate) => {
  // Guard against multiple simultaneous logout calls creating a redirect loop
  if (isLoggingOut) return;
  isLoggingOut = true;

  localStorage.removeItem("dwt-cust-tok");
  localStorage.removeItem("customer-name");
  localStorage.removeItem("phone_number");
  localStorage.removeItem("event-info");

  try {
    localStorage.setItem("logout", Date.now().toString());
  } catch (e) {
    // ignore storage write failure
  }

  if (typeof navigate === "function") {
    navigate("/login");
    isLoggingOut = false; // Reset for React Router navigation (no full reload)
    return;
  }

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

export default HandleLogout;